export { default } from './NewsWebFilter';
